module.exports = __webpack_public_path__ + "img/04demo@2x.40a56f9d.png";